// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  margin-bottom: 30px;
  font-family: MuseoSans-500;
  font-size: 18px;
  color: #404141;
}

p {
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #404141;
  letter-spacing: 0.01px;
  line-height: 1.2;
  margin-bottom: 0px;
}

p.phantoms-intro:last-of-type {
  margin-bottom: 30px;
}

form label {
  font-family: MuseoSans-300;
  font-size: 13px;
  color: #404141;
  height: 28px;
}

span.info > img {
	margin-top: 4px;
}

select {
  height: 30px !important;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-right: 28px;
  -o-appearance: none;
  appearance: none;
  border-radius: 0px;
  -moz-border-radius: 0px;
  -webkit-border-radius: 0px;
  border: 1px solid #BFBFC0;
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #404141;
}

select::-ms-expand {
  display: none;
}

.line-select input {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 170px;
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #404141;
  border-right: none;
 }

select + span {
  float: right;
  margin-top: -27px;
  margin-right: 5px;
  pointer-events: none;
  background-color: #fff;
  padding-right: 5px;
  height: 14px;
}

select + span img {
  width: 14px;
  height: 14px;
  vertical-align: -3px;
}

hr {
  margin: 30px -18px;
}

.text-danger {
  font-family: MuseoSans-500;
  font-size: 11px;
  color: #ED1C24;
  margin-top: 4px;
}

.send-emails .title {
  margin-bottom: 40px;
}

.send-emails button {
  margin: 0px;
  width: 250px;
}

.send-all-emails {
  margin-bottom: 18px;
}

.send-admin-emails {
  margin-bottom: 40px;
}

.send-all-emails span,
.send-admin-emails span {
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #404141;
  margin-left: 10px;
}

.send-all-emails span.send-warning,
.send-admin-emails span.send-warning {
  display: block;
}

.send-all-emails div.send-description,
.send-admin-emails div.send-description {
  display: inline-block;
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #404141;
}

.nomargin {
  padding-left: 0px !important;
  padding-right: 5px !important;
}

.send-result {
  height: 28px;
}

.send-all-emails span.send-success,
.send-admin-emails span.send-success {
  font-family: MuseoSans-700;
  color: #3fac49;
}

.line-height-small {
  line-height: 1;
}

.send-all-emails span.send-warning,
.send-admin-emails span.send-warning {
  font-family: MuseoSans-700;
  color: #ed1c24;
  margin-top: 3px;
}

.send-all-emails span.send-warning img,
.send-admin-emails span.send-warning img {
  margin-right: 5px;
  vertical-align: -1px;
}

.send-admin-emails span.no-admin-warning {
  margin-left: 0px;
}

.send-success img {
  margin-right: 5px;
  margin-bottom: 1px;
  width: 12px;
  height: 12px;
}

.send-emails .inputbox {
  margin-bottom: 30px;
  margin-top: -10px;
}

.send-emails .inputbox .form-group {
  margin: 0px;
}

.send-emails .inputbox label {
  margin-bottom: 0px;
}

.send-emails .inputbox input {
  width: 200px;
  height: 28px;
  margin-bottom: 0px;
  margin-right: 10px;
  vertical-align: bottom;
  display: inline-block;
}

.send-emails .inputbox button{
  width: 100px;
  margin: 0px;
}

.send-emails .account-id {
  margin-top: 14px;
  margin-bottom: 40px;
  font-family: MuseoSans-500;
  font-size: 18px;
  color: #404141;
}

.send-emails .account-id span.info > img {
  margin-top: 3px;
}

.send-emails .reminder {
  font-family: MuseoSans-500;
  font-size: 12px;
  color: #399041;
  margin-top: 7px;
}

:host >>> p span {
  font-family: MuseoSans-500;
  color: #1C1D1D;
}

p.more-settings-description {
  text-align: center;
  line-height: 1.25;
  margin-bottom: 20px;
}

:host >>> p.more-settings-description span {
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #404141;
  letter-spacing: 0.01px;
}

p.more-settings-description button {
  font-family: MuseoSans-300;
  font-size: 12px;
  letter-spacing: 0.01px;
  padding: 0px;
  width: auto;
  display: inline-block;
  text-decoration: none;
}

p.more-settings-description button:hover {
  text-decoration: underline;
}

.actions {
  position: relative;
  bottom: 20px;
  right: 10px;
  margin-top: 36px;
  margin-right: -10px;
}

.actions button {
  width: 100px;
}

.btn-primary {
  margin-left: 10px;
}

.checkbox {
  padding-left: 16px;
  margin-top: 10px;
  margin-bottom: 40px;
  position: relative;
}

.checkbox-label {
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #404141;
  letter-spacing: 0.01px;
  line-height: 1.2;
  margin-bottom: 0px;
  position: absolute;
  margin-left:10px;
  margin-top: 3px;
}

.checkbox-style {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: solid 1px #d1d6db;
  background-image: linear-gradient(to top, #f2f4f7, #ffffff);
}

`, "",{"version":3,"sources":["webpack://./src/app/components/office-connect/office-connect.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EAGnB,mBAAmB;EAEnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,kBAAkB;CACnB;;AAED;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2DAA2D;AAC7D","sourcesContent":[".title {\n  margin-bottom: 30px;\n  font-family: MuseoSans-500;\n  font-size: 18px;\n  color: #404141;\n}\n\np {\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #404141;\n  letter-spacing: 0.01px;\n  line-height: 1.2;\n  margin-bottom: 0px;\n}\n\np.phantoms-intro:last-of-type {\n  margin-bottom: 30px;\n}\n\nform label {\n  font-family: MuseoSans-300;\n  font-size: 13px;\n  color: #404141;\n  height: 28px;\n}\n\nspan.info > img {\n\tmargin-top: 4px;\n}\n\nselect {\n  height: 30px !important;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  padding-right: 28px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -o-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  border-radius: 0px;\n  -moz-border-radius: 0px;\n  -webkit-border-radius: 0px;\n  border: 1px solid #BFBFC0;\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #404141;\n}\n\nselect::-ms-expand {\n  display: none;\n}\n\n.line-select input {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 170px;\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #404141;\n  border-right: none;\n }\n\nselect + span {\n  float: right;\n  margin-top: -27px;\n  margin-right: 5px;\n  pointer-events: none;\n  background-color: #fff;\n  padding-right: 5px;\n  height: 14px;\n}\n\nselect + span img {\n  width: 14px;\n  height: 14px;\n  vertical-align: -3px;\n}\n\nhr {\n  margin: 30px -18px;\n}\n\n.text-danger {\n  font-family: MuseoSans-500;\n  font-size: 11px;\n  color: #ED1C24;\n  margin-top: 4px;\n}\n\n.send-emails .title {\n  margin-bottom: 40px;\n}\n\n.send-emails button {\n  margin: 0px;\n  width: 250px;\n}\n\n.send-all-emails {\n  margin-bottom: 18px;\n}\n\n.send-admin-emails {\n  margin-bottom: 40px;\n}\n\n.send-all-emails span,\n.send-admin-emails span {\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #404141;\n  margin-left: 10px;\n}\n\n.send-all-emails span.send-warning,\n.send-admin-emails span.send-warning {\n  display: block;\n}\n\n.send-all-emails div.send-description,\n.send-admin-emails div.send-description {\n  display: inline-block;\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #404141;\n}\n\n.nomargin {\n  padding-left: 0px !important;\n  padding-right: 5px !important;\n}\n\n.send-result {\n  height: 28px;\n}\n\n.send-all-emails span.send-success,\n.send-admin-emails span.send-success {\n  font-family: MuseoSans-700;\n  color: #3fac49;\n}\n\n.line-height-small {\n  line-height: 1;\n}\n\n.send-all-emails span.send-warning,\n.send-admin-emails span.send-warning {\n  font-family: MuseoSans-700;\n  color: #ed1c24;\n  margin-top: 3px;\n}\n\n.send-all-emails span.send-warning img,\n.send-admin-emails span.send-warning img {\n  margin-right: 5px;\n  vertical-align: -1px;\n}\n\n.send-admin-emails span.no-admin-warning {\n  margin-left: 0px;\n}\n\n.send-success img {\n  margin-right: 5px;\n  margin-bottom: 1px;\n  width: 12px;\n  height: 12px;\n}\n\n.send-emails .inputbox {\n  margin-bottom: 30px;\n  margin-top: -10px;\n}\n\n.send-emails .inputbox .form-group {\n  margin: 0px;\n}\n\n.send-emails .inputbox label {\n  margin-bottom: 0px;\n}\n\n.send-emails .inputbox input {\n  width: 200px;\n  height: 28px;\n  margin-bottom: 0px;\n  margin-right: 10px;\n  vertical-align: bottom;\n  display: inline-block;\n}\n\n.send-emails .inputbox button{\n  width: 100px;\n  margin: 0px;\n}\n\n.send-emails .account-id {\n  margin-top: 14px;\n  margin-bottom: 40px;\n  font-family: MuseoSans-500;\n  font-size: 18px;\n  color: #404141;\n}\n\n.send-emails .account-id span.info > img {\n  margin-top: 3px;\n}\n\n.send-emails .reminder {\n  font-family: MuseoSans-500;\n  font-size: 12px;\n  color: #399041;\n  margin-top: 7px;\n}\n\n:host >>> p span {\n  font-family: MuseoSans-500;\n  color: #1C1D1D;\n}\n\np.more-settings-description {\n  text-align: center;\n  line-height: 1.25;\n  margin-bottom: 20px;\n}\n\n:host >>> p.more-settings-description span {\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #404141;\n  letter-spacing: 0.01px;\n}\n\np.more-settings-description button {\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  letter-spacing: 0.01px;\n  padding: 0px;\n  width: auto;\n  display: inline-block;\n  text-decoration: none;\n}\n\np.more-settings-description button:hover {\n  text-decoration: underline;\n}\n\n.actions {\n  position: relative;\n  bottom: 20px;\n  right: 10px;\n  margin-top: 36px;\n  margin-right: -10px;\n}\n\n.actions button {\n  width: 100px;\n}\n\n.btn-primary {\n  margin-left: 10px;\n}\n\n.checkbox {\n  padding-left: 16px;\n  margin-top: 10px;\n  margin-bottom: 40px;\n  position: relative;\n}\n\n.checkbox-label {\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #404141;\n  letter-spacing: 0.01px;\n  line-height: 1.2;\n  margin-bottom: 0px;\n  position: absolute;\n  margin-left:10px;\n  margin-top: 3px;\n}\n\n.checkbox-style {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  border: solid 1px #d1d6db;\n  background-image: linear-gradient(to top, #f2f4f7, #ffffff);\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
